import { render, staticRenderFns } from "./home.vue?vue&type=template&id=41b84d89"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41b84d89')) {
      api.createRecord('41b84d89', component.options)
    } else {
      api.reload('41b84d89', component.options)
    }
    module.hot.accept("./home.vue?vue&type=template&id=41b84d89", function () {
      api.rerender('41b84d89', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/pages/home.vue"
export default component.exports